import axios from "axios";
import AuthServices from "./AuthServices";

const PillServices = {
  add: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/pill`,
      {
        enterprises: data.enterprises,
      }
    );
    return response;
  },
  delete: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/pill`,
      {
        pill_id: data.pill_id,
        name: data.name,
        enterprises_delete: data.enterprises_delete,
      }
    );
    return response;
  },
  edit: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/pill`,
      {
        pill_id: data.pill_id,
        name: data.name,
        description: data.description,
        type: data.type,
        url: data.url,
        enterprises: data.enterprises,
        enterprises_delete: data.enterprises_delete,
        capsule_strapi_id: data.capsule_strapi_id,
      }
    );
    return response;
  },
};

export default PillServices;
